import { RoadDetails, LevelName, LevelNameValues, Level, LevelPurchaseDetails } from './level';
import { level1 } from './level1';
import { level2 } from './level2';
import { level3 } from './level3';
import { level4 } from './level4';
import { level5 } from './level5';
import { level6 } from './level6';
import { level7 } from './level7';
import { level8 } from './level8';
import { level9 } from './level9';

export class LevelUtil {
  public static defaultLevelPurchaseDetails: Record<LevelNameValues, LevelPurchaseDetails> = {
    [LevelName.Level1]: {
      linkedLevel: LevelName.Level1,
      price: 50,
      nextLevel: LevelName.Level2,
      nextLevelPrice: 50
    },
    [LevelName.Level2]: {
      linkedLevel: LevelName.Level2,
      price: 50,
      nextLevel: LevelName.Level3,
      nextLevelPrice: 80
    },
    [LevelName.Level3]: {
      linkedLevel: LevelName.Level3,
      price: 80,
      nextLevel: LevelName.Level4,
      nextLevelPrice: 100
    },
    [LevelName.Level4]: {
      linkedLevel: LevelName.Level4,
      price: 100,
      nextLevel: LevelName.Level5,
      nextLevelPrice: 120
    },
    [LevelName.Level5]: {
      linkedLevel: LevelName.Level5,
      price: 120,
      nextLevel: LevelName.Level6,
      nextLevelPrice: 150
    },
    [LevelName.Level6]: {
      linkedLevel: LevelName.Level6,
      price: 150,
      nextLevel: LevelName.Level7,
      nextLevelPrice: 180
    },
    [LevelName.Level7]: {
      linkedLevel: LevelName.Level7,
      price: 180,
      nextLevel: LevelName.Level8,
      nextLevelPrice: 200
    },
    [LevelName.Level8]: {
      linkedLevel: LevelName.Level8,
      price: 200,
      nextLevel: LevelName.Level9,
      nextLevelPrice: 250
    },
    [LevelName.Level9]: {
      linkedLevel: LevelName.Level9,
      price: 250,
      nextLevel: undefined,
      nextLevelPrice: undefined
    }
  };

  protected static roadMiddle: number = 0;
  protected static levelNameToLevelLookup: Record<LevelNameValues, Level> = {
    [LevelName.Level1]: level1,
    [LevelName.Level2]: level2,
    [LevelName.Level3]: level3,
    [LevelName.Level4]: level4,
    [LevelName.Level5]: level5,
    [LevelName.Level6]: level6,
    [LevelName.Level7]: level7,
    [LevelName.Level8]: level8,
    [LevelName.Level9]: level9
  };

  public static laneBoundariesByLane: { [key: number]: number } = {};
  public static laneBoundaries: number[] = [];

  public static getLevelFromName(levelName: LevelNameValues) {
    return this.levelNameToLevelLookup[levelName];
  }

  public static generateMeasurements(roadDetails: RoadDetails) {
    LevelUtil.roadMiddle = this.calculateRoadYMid(roadDetails);
    this.calculateLaneBoundaries(roadDetails);
  }

  public static get RoadMiddle() {
    return LevelUtil.roadMiddle;
  }

  public static getLaneYFromTopToTop(laneNumber: number, roadDetails: RoadDetails) {
    let scale = this.getLaneYScale(laneNumber, roadDetails);
    return roadDetails.laneHeight * scale;
  }

  public static getLaneYChangeMidToMid(prevLaneNumber: number, laneNumber: number, roadDetails: RoadDetails) {
    let preLane = this.getLaneYFromTopToTop(prevLaneNumber, roadDetails);
    let curLane = this.getLaneYFromTopToTop(laneNumber, roadDetails);

    return preLane + curLane * 0.5 - preLane * 0.5;
  }

  // public static getLaneY(laneNumber: number, roadDetails: RoadDetails) {
  //   return roadDetails.startPointY + roadDetails.laneHeight * laneNumber + roadDetails.laneHeight * 0.5;
  // }

  public static getYFromTopToLaneBot(laneNumber: number, roadDetails: RoadDetails) {
    let laneHeight = -50;
    for (let i = 0; i <= laneNumber; i++) {
      let scale = this.getLaneYScale(i, roadDetails);
      laneHeight += roadDetails.laneHeight * scale;
    }

    // console.log('Lane Y Height', laneHeight);
    return roadDetails.startPointY + laneHeight;
  }

  public static getLaneYFromTopToMid(laneNumber: number, roadDetails: RoadDetails) {
    let laneHeight = 0;
    for (let i = 0; i <= laneNumber; i++) {
      let scale = this.getLaneYScale(i, roadDetails);

      if (i == laneNumber) laneHeight += roadDetails.laneHeight * scale * 0.5;
      else laneHeight += roadDetails.laneHeight * scale;
    }

    // console.log('Lane Y Mid Height', roadDetails.startPointY, laneHeight, roadDetails.startPointY + laneHeight);
    return roadDetails.startPointY + laneHeight;
  }

  // public static getLaneYMiddle(laneNumber: number, roadDetails: RoadDetails) {
  //   return roadDetails.startPointY + roadDetails.laneHeight * laneNumber + roadDetails.laneHeight * 0.5;
  // }

  public static calculateRoadYMid(roadDetails: RoadDetails) {
    return (
      roadDetails.startPointY +
      (this.getLaneYFromTopToTop(0, roadDetails) +
        this.getLaneYFromTopToTop(1, roadDetails) +
        this.getLaneYFromTopToTop(2, roadDetails) +
        this.getLaneYFromTopToTop(3, roadDetails)) *
        0.5
    );
    // return roadDetails.startPointY + 185.5;
  }

  public static calculateLaneBoundaries(roadDetails: RoadDetails) {
    let laneY = roadDetails.startPointY;

    for (let i = 0; i < roadDetails.laneCount; i++) {
      this.laneBoundariesByLane[i] = laneY;
      this.laneBoundaries.push(laneY);

      let scale = this.getLaneYScale(i, roadDetails);
      laneY += roadDetails.laneHeight * scale;
    }

    this.laneBoundariesByLane[roadDetails.laneCount] = laneY;
    this.laneBoundaries.push(laneY);
  }

  public static getLaneYScale(laneNumber: number, roadDetails: RoadDetails) {
    return 1 - (roadDetails.laneCount - laneNumber - 1) * roadDetails.laneScale;
  }

  public static getLaneYVehicleScale(laneNumber: number, roadDetails: RoadDetails) {
    return 1 - (roadDetails.laneCount - laneNumber) * roadDetails.laneVehicleScale;
  }

  public static getPavementY(roadDetails: RoadDetails) {
    return roadDetails.startPointY + roadDetails.pavementY;
  }

  public static getPavementYMid(roadDetails: RoadDetails) {
    return roadDetails.startPointY + roadDetails.pavementY + roadDetails.pavementHeight * 0.5;
  }

  public static getVehicleLaneYFromTopToMid(laneNumber: number, roadDetails: RoadDetails) {
    // console.log('Vehicle Lane Y Mid Height', this.getYFromTopToLaneMiddle(laneNumber, roadDetails) + roadDetails.vehicleOffset);
    return this.getLaneYFromTopToMid(laneNumber, roadDetails) + roadDetails.vehicleOffset;
  }

  public static getVehicleLaneY(laneNumber: number, roadDetails: RoadDetails) {
    let scale = this.getLaneYScale(laneNumber, roadDetails);
    return roadDetails.laneHeight * scale;
  }

  public static getVehicleStartPoint(laneNumber: number, startIndentX: number, roadDetails: RoadDetails): [x: number, y: number] {
    let startPointX = roadDetails.startPointX + startIndentX;
    // let startPointY = roadDetails.startPointY + roadDetails.laneHeight * laneNumber + roadDetails.laneHeight * 0.5;
    let startPointY = this.getVehicleLaneYFromTopToMid(laneNumber, roadDetails);

    return [startPointX, startPointY];
  }
}
